import { SVGProps, Ref, forwardRef } from 'react';

export const ComputerOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 19.991C.903 19.871 0 18.484 0 11c0-7.875 1-9 8-9h8c7 0 8 1.125 8 9 0 7.484-.903 8.872-7 8.991V22H7zM8 18.2c-1.734 0-2.948-.073-3.83-.26-.848-.18-1.227-.432-1.45-.683-.244-.275-.503-.775-.68-1.826-.176-1.055-.24-2.474-.24-4.431s.064-3.376.24-4.431c.177-1.051.436-1.551.68-1.826.223-.251.602-.504 1.45-.683.882-.187 2.096-.26 3.83-.26h8c1.734 0 2.948.073 3.83.26.848.18 1.227.432 1.45.683.244.275.503.775.68 1.826.176 1.055.24 2.474.24 4.431s-.064 3.376-.24 4.431c-.177 1.051-.436 1.551-.68 1.826-.224.251-.602.503-1.45.683-.882.187-2.096.26-3.83.26z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ComputerOutlinedSize24Glyph.displayName = 'ComputerOutlinedSize24Glyph';
